export default __webpack_public_path__ + "static/media/ble2.1443d562.png";